import { FiChevronRight } from "react-icons/fi";

import { AiOutlineContainer } from "react-icons/ai";

import { 
  MdSecurity,
  MdDns,
  MdAnalytics
} from "react-icons/md";

export function renderinfraMonitoring () {
    return (
  <div className="transition-opacity duration-300">
    {/* Breadcrumb */}
    <nav className="flex flex-wrap items-center gap-2 text-sm text-[#9a734c] mb-8">
      <a className="hover:text-primary hover:underline" href="#">Netraa APM</a>
      <FiChevronRight className="text-[14px]" />
      <span>Product Capabilities</span>
      <FiChevronRight className="text-[14px]" />
      <span className="text-[#1b140d] dark:text-white font-medium">Infra Monitoring</span>
    </nav>

    {/* Header */}
    <div className="mb-10 border-b border-[#e5e7eb] dark:border-[#3a2e25] pb-8">
      <h1 className="text-4xl md:text-5xl font-bold text-[#1b140d] dark:text-white tracking-tight mb-4 font-display">
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
          Infrastructure Monitoring
        </span>
      </h1>
      <p className="text-lg text-gray-600 dark:text-gray-300 leading-relaxed">
        Infrastructure performance is the foundation of application reliability. Netraa’s Infrastructure Monitoring provides a correlated view of your entire stack, linking physical and virtual resource usage directly to application traces. By unifying metrics from hosts, containers, and orchestration layers, teams can pinpoint whether latency stems from code inefficiency or underlying resource contention in real-time.
      </p>
    </div>

{/* Host Monitoring */}
<section className="mb-16 scroll-mt-24" id="host-monitoring">

  <h2 className="text-2xl font-bold text-[#1b140d] dark:text-white mb-4 flex items-center gap-2 font-display">
    <span className="bg-primary/10 text-primary p-1.5 rounded-lg material-symbols-outlined">
      dns
    </span>
    Host Monitoring
  </h2>

  {/* Linux Service Overview */}
  <div className="mb-6">
    <h3 className="text-lg font-bold text-[#1b140d] dark:text-white mb-2 font-display">
      Linux Service Overview
    </h3>

    <p className="text-gray-600 dark:text-gray-300 leading-relaxed mb-4">
      Gain immediate insights into the physical or virtual hosts powering your applications.
      Netraa's agent collects high-resolution metrics for core OS indicators such as CPU
      load averages, memory page faults, disk I/O latency, and network throughput.
      Additionally, you can monitor the status of critical system services (systemd, init.d)
      to ensure the backbone of your deployment remains healthy and responsive under load.
    </p>
  </div>

  {/* Process List Analysis */}
  <div className="mb-8">
    <h3 className="text-lg font-bold text-[#1b140d] dark:text-white mb-2 font-display">
      Process List Analysis
    </h3>

    <p className="text-gray-600 dark:text-gray-300 leading-relaxed mb-6">
      Achieve granular visibility into resource consumption at the process level.
      The live Process List automatically surfaces the top consumers of CPU and
      Memory resources, allowing DevOps engineers to instantly identify runaway
      processes, memory leaks, or zombie threads that are degrading host performance.
    </p>
  </div>

  {/* Host Metrics Card */}
  <div className="bg-white dark:bg-[#2c2219] border border-[#e5e7eb] dark:border-[#3a2e25] rounded-xl p-4 md:p-6 shadow-sm mb-6 relative overflow-hidden">

    {/* Header */}
    <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 mb-6">

      <div className="flex items-center gap-3 min-w-0">
        <div className="bg-gray-100 dark:bg-gray-800 p-2 rounded-lg shrink-0">
          <span className="material-symbols-outlined text-gray-600 dark:text-gray-300">
            terminal
          </span>
        </div>

        <div className="min-w-0">
          <div className="text-sm font-bold text-[#1b140d] dark:text-white font-display truncate">
            prod-worker-04
          </div>

          <div className="text-xs text-green-600 flex items-center gap-1 font-medium flex-wrap">
            <span className="size-2 bg-green-500 rounded-full shrink-0"></span>
            Online (Uptime: 45d 12h)
          </div>
        </div>
      </div>

      <div className="bg-gray-50 dark:bg-[#1f1610] px-3 py-1 rounded text-xs font-mono text-gray-500 border border-gray-200 dark:border-gray-700 self-start md:self-auto break-all">
        192.168.1.45
      </div>
    </div>

    {/* Metrics Grid */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">

      {/* CPU */}
      <div className="p-4 rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-[#1f1610]">
        <div className="text-xs text-gray-500 mb-1 font-bold uppercase">
          CPU Usage
        </div>

        <div className="flex items-end gap-2 mb-2 flex-wrap">
          <span className="text-2xl font-bold text-[#1b140d] dark:text-white font-display">
            72%
          </span>

          <span className="text-xs text-red-500 font-bold mb-1">
            ▲ 12%
          </span>
        </div>

        <svg className="w-full h-10 overflow-visible" preserveAspectRatio="none">
          <path
            d="M0,40 Q10,35 20,38 T40,30 T60,25 T80,10 T100,15 T120,5 T140,20 T160,18"
            fill="none"
            stroke="#ec7f13"
            strokeWidth="2"
          ></path>

          <linearGradient id="cpu-grad" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="#ec7f13" stopOpacity="0.2"></stop>
            <stop offset="100%" stopColor="#ec7f13" stopOpacity="0"></stop>
          </linearGradient>

          <path
            d="M0,40 Q10,35 20,38 T40,30 T60,25 T80,10 T100,15 T120,5 T140,20 T160,18 V40 H0 Z"
            fill="url(#cpu-grad)"
            stroke="none"
          ></path>
        </svg>
      </div>

      {/* Memory */}
      <div className="p-4 rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-[#1f1610]">
        <div className="text-xs text-gray-500 mb-1 font-bold uppercase">
          Memory
        </div>

        <div className="flex items-end gap-2 mb-2 flex-wrap">
          <span className="text-2xl font-bold text-[#1b140d] dark:text-white font-display">
            14.2 GB
          </span>

          <span className="text-xs text-gray-400 font-bold mb-1">
            / 16 GB
          </span>
        </div>

        <svg className="w-full h-10 overflow-visible" preserveAspectRatio="none">
          <path
            d="M0,35 Q20,35 40,32 T80,25 T120,22 T160,20"
            fill="none"
            stroke="#3b82f6"
            strokeWidth="2"
          ></path>

          <path
            d="M0,35 Q20,35 40,32 T80,25 T120,22 T160,20 V40 H0 Z"
            fill="rgba(59, 130, 246, 0.1)"
            stroke="none"
          ></path>
        </svg>
      </div>

      {/* Disk I/O */}
      <div className="p-4 rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-[#1f1610]">
        <div className="text-xs text-gray-500 mb-1 font-bold uppercase">
          Disk I/O
        </div>

        <div className="flex items-end gap-2 mb-2 flex-wrap">
          <span className="text-2xl font-bold text-[#1b140d] dark:text-white font-display">
            45 MB/s
          </span>

          <span className="text-xs text-green-500 font-bold mb-1">
            Normal
          </span>
        </div>

        <svg className="w-full h-10 overflow-visible" preserveAspectRatio="none">
          <path
            d="M0,38 Q20,38 40,38 T60,10 T80,38 T100,38 T120,5 T140,38 T160,38"
            fill="none"
            stroke="#10b981"
            strokeWidth="2"
          ></path>
        </svg>
      </div>
    </div>

    {/* Process Table */}
    <div className="border border-[#e5e7eb] dark:border-[#3a2e25] rounded-lg overflow-x-auto">

      <table className="w-full min-w-[520px] text-left text-xs">

        <thead className="bg-gray-100 dark:bg-gray-800 text-gray-500 font-bold uppercase">
          <tr>
            <th className="px-4 py-2">PID</th>
            <th className="px-4 py-2">Process</th>
            <th className="px-4 py-2">User</th>
            <th className="px-4 py-2 text-right">CPU%</th>
            <th className="px-4 py-2 text-right">Mem%</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-gray-100 dark:divide-gray-800 bg-white dark:bg-[#2c2219]">

          <tr className="hover:bg-gray-50 dark:hover:bg-[#362b22]">
            <td className="px-4 py-2 font-mono text-gray-500">1142</td>
            <td className="px-4 py-2 text-[#1b140d] dark:text-white">Java</td>
            <td className="px-4 py-2 text-gray-500">netraa</td>
            <td className="px-4 py-2 text-right text-orange-600 font-bold">45.2%</td>
            <td className="px-4 py-2 text-right">12.1%</td>
          </tr>

          <tr className="hover:bg-gray-50 dark:hover:bg-[#362b22]">
            <td className="px-4 py-2 font-mono text-gray-500">892</td>
            <td className="px-4 py-2 font-medium text-[#1b140d] dark:text-white">dockerd</td>
            <td className="px-4 py-2 text-gray-500">root</td>
            <td className="px-4 py-2 text-right">8.4%</td>
            <td className="px-4 py-2 text-right">4.5%</td>
          </tr>

          <tr className="hover:bg-gray-50 dark:hover:bg-[#362b22]">
            <td className="px-4 py-2 font-mono text-gray-500">2201</td>
            <td className="px-4 py-2 font-medium text-[#1b140d] dark:text-white">nginx</td>
            <td className="px-4 py-2 text-gray-500">www-data</td>
            <td className="px-4 py-2 text-right">2.1%</td>
            <td className="px-4 py-2 text-right">1.2%</td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>
</section>

    {/* Container Monitoring */}
    <section className="mb-16 scroll-mt-24" id="container-monitoring">
      <h2 className="text-2xl font-bold text-[#1b140d] dark:text-white mb-4 flex items-center gap-2 font-display">
        <span className="bg-primary/10 text-primary p-1.5 rounded-lg material-symbols-outlined"><AiOutlineContainer/></span>
        Container Monitoring
      </h2>

      <div className="mb-6">
        <h3 className="text-lg font-bold text-[#1b140d] dark:text-white mb-2 font-display">Modern Application Platforms</h3>
        <p className="text-gray-600 dark:text-gray-300 leading-relaxed mb-4">
          As applications shift to microservices, visibility into the orchestration layer is paramount. Netraa tracks container-level resource usage across dynamic environments like Kubernetes and Docker Swarm, helping teams manage the ephemeral nature of containerized workloads.
        </p>
      </div>

      <div className="mb-8">
        <h3 className="text-lg font-bold text-[#1b140d] dark:text-white mb-2 font-display">Container Dashboard</h3>
        <p className="text-gray-600 dark:text-gray-300 leading-relaxed mb-6">
          The Container Dashboard aggregates metrics across nodes, namespaces, and deployments to provide a unified health view. It allows you to visualize pod health in real-time, identifying resource imbalances, CPU throttling, or memory limits (OOMKilled events) that impose runtime constraints on your services.
        </p>
      </div>

      <div className="bg-white dark:bg-[#2c2219] border border-[#e5e7eb] dark:border-[#3a2e25] rounded-xl p-6 shadow-sm">
        <div className="flex justify-between items-center mb-4">
          <h4 className="text-sm font-bold uppercase text-gray-500 font-display">Cluster: prod-us-east-1</h4>
          <div className="flex gap-2 text-xs">
            <span className="px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 rounded">12 Running</span>
            <span className="px-2 py-1 bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400 rounded">1 OOMKilled</span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* Pod Cards */}
          <div className="border border-[#e5e7eb] dark:border-[#3a2e25] rounded-xl p-3 bg-gray-50 dark:bg-[#1f1610] hover:shadow-md transition-shadow cursor-pointer">
            <div className="flex justify-between items-start mb-2">
              <div className="flex items-center gap-2">
                <span className="size-2 rounded-full bg-green-500"></span>
                <span className="text-sm font-bold text-[#1b140d] dark:text-white truncate max-w-[100px]">auth-svc-x82</span>
              </div>
              <span className="text-[10px] text-gray-400 font-mono">pod-a1</span>
            </div>
            <div className="space-y-2">
              <div className="text-[10px] text-gray-500 flex justify-between"><span>CPU</span> <span>450m / 1000m</span></div>
              <div className="h-1.5 w-full bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
                <div className="h-full bg-blue-500 w-[45%] rounded-full"></div>
              </div>
              <div className="text-[10px] text-gray-500 flex justify-between"><span>MEM</span> <span>210Mi / 512Mi</span></div>
              <div className="h-1.5 w-full bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
                <div className="h-full bg-purple-500 w-[41%] rounded-full"></div>
              </div>
            </div>
          </div>

          <div className="border border-orange-200 dark:border-orange-900/50 rounded-xl p-3 bg-orange-50 dark:bg-orange-900/10 hover:shadow-md transition-shadow cursor-pointer">
            <div className="flex justify-between items-start mb-2">
              <div className="flex items-center gap-2">
                <span className="size-2 rounded-full bg-orange-500 animate-pulse"></span>
                <span className="text-sm font-bold text-[#1b140d] dark:text-white truncate max-w-[100px]">payment-svc-99</span>
              </div>
              <span className="text-[10px] text-gray-400 font-mono">pod-b2</span>
            </div>
            <div className="space-y-2">
              <div className="text-[10px] text-gray-500 flex justify-between"><span>CPU</span> <span className="text-orange-600 font-bold">980m / 1000m</span></div>
              <div className="h-1.5 w-full bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
                <div className="h-full bg-orange-500 w-[98%] rounded-full"></div>
              </div>
              <div className="text-[10px] text-gray-500 flex justify-between"><span>MEM</span> <span>400Mi / 512Mi</span></div>
              <div className="h-1.5 w-full bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
                <div className="h-full bg-purple-500 w-[78%] rounded-full"></div>
              </div>
            </div>
          </div>

          <div className="border border-[#e5e7eb] dark:border-[#3a2e25] rounded-xl p-3 bg-gray-50 dark:bg-[#1f1610] hover:shadow-md transition-shadow cursor-pointer">
            <div className="flex justify-between items-start mb-2">
              <div className="flex items-center gap-2">
                <span className="size-2 rounded-full bg-green-500"></span>
                <span className="text-sm font-bold text-[#1b140d] dark:text-white truncate max-w-[100px]">frontend-v2</span>
              </div>
              <span className="text-[10px] text-gray-400 font-mono">pod-c3</span>
            </div>
            <div className="space-y-2">
              <div className="text-[10px] text-gray-500 flex justify-between"><span>CPU</span> <span>120m / 500m</span></div>
              <div className="h-1.5 w-full bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
                <div className="h-full bg-blue-500 w-[24%] rounded-full"></div>
              </div>
              <div className="text-[10px] text-gray-500 flex justify-between"><span>MEM</span> <span>150Mi / 256Mi</span></div>
              <div className="h-1.5 w-full bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
                <div className="h-full bg-purple-500 w-[58%] rounded-full"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

 {/* NGINX Monitoring */}
<section className="mb-16 scroll-mt-24" id="nginx-monitoring">
  <h2 className="text-2xl font-bold text-[#1b140d] dark:text-white mb-4 flex items-center gap-2 font-display">
    <span className="bg-primary/10 text-primary p-1.5 rounded-lg material-symbols-outlined">
      <MdSecurity />
    </span>
    NGINX Monitoring
  </h2>

  {/* Text content */}
  <div className="mb-6">
    <h3 className="text-lg font-bold text-[#1b140d] dark:text-white mb-2 font-display">
      Ingress and Web Tier Observability
    </h3>
    <p className="text-gray-600 dark:text-gray-300 leading-relaxed mb-4">
      Netraa's NGINX integration parses your access logs and stub_status module to provide deep visibility into your web tier. <strong>Instance Metrics</strong> track global server health including request rates, connection drops, and bandwidth utilization. Simultaneously, <strong>Endpoint Metrics</strong> offer granular details on latency and error rates (4xx/5xx) per route, helping you identify which upstream servers are causing bottlenecks at the load balancer level.
    </p>
    <ul className="list-disc list-inside text-sm text-gray-500 dark:text-gray-400 space-y-1 ml-1">
      <li>Active client connections</li>
      <li>Dropped packets per second</li>
      <li>Bandwidth utilization (Ingress/Egress)</li>
    </ul>
  </div>

  {/* Image / Card */}
  <div className="w-full flex justify-center">
    <div className="w-full max-w-md bg-white dark:bg-[#2c2219] border border-[#e5e7eb] dark:border-[#3a2e25] rounded-xl p-4 shadow-sm">
      <div className="flex items-center gap-3 mb-4">
        <div className="size-10 bg-[#009639]/10 text-[#009639] rounded-lg flex items-center justify-center">
          <span className="font-bold text-xs">NGINX</span>
        </div>
        <div>
          <div className="text-xs text-gray-500 uppercase font-bold">Requests / Sec</div>
          <div className="text-2xl font-bold text-[#1b140d] dark:text-white font-display">2,450</div>
        </div>
      </div>
      <div className="h-24 w-full relative mb-2">
        <svg className="w-full h-full overflow-visible" preserveAspectRatio="none">
          <path d="M0,80 L20,70 L40,75 L60,40 L80,50 L100,30 L120,45 L140,20 L160,25 L180,10 L200,15 L220,5 L240,20" fill="none" stroke="#009639" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
          <linearGradient id="nginx-grad" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="#009639" stopOpacity="0.1"></stop>
            <stop offset="100%" stopColor="#009639" stopOpacity="0"></stop>
          </linearGradient>
          <path d="M0,80 L20,70 L40,75 L60,40 L80,50 L100,30 L120,45 L140,20 L160,25 L180,10 L200,15 L220,5 L240,20 V90 H0 Z" fill="url(#nginx-grad)" stroke="none"></path>
        </svg>
      </div>
      <div className="grid grid-cols-2 gap-2 text-xs border-t border-gray-100 dark:border-gray-800 pt-3">
        <div>
          <span className="text-gray-400 block">Active Conn</span>
          <span className="font-bold text-[#1b140d] dark:text-white">8,921</span>
        </div>
        <div className="text-right">
          <span className="text-gray-400 block">Dropped</span>
          <span className="font-bold text-red-500">0.01%</span>
        </div>
      </div>
    </div>
  </div>
</section>


    {/* Redis Monitoring */}
    <section className="mb-20 scroll-mt-24" id="redis-monitoring">
      <h2 className="text-2xl font-bold text-[#1b140d] dark:text-white mb-4 flex items-center gap-2 font-display">
        <span className="bg-primary/10 text-primary p-1.5 rounded-lg material-symbols-outlined"><MdDns/></span>
        Redis Monitoring
      </h2>
      <p className="text-gray-600 dark:text-gray-300 leading-relaxed mb-6">
        Ensure your caching strategy effectively offloads database pressure with comprehensive <strong>Cache Layer Visibility</strong>. Netraa provides deep insights into Redis performance to prevent cache stampedes and latency spikes.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-gray-50 dark:bg-[#1f1610] border border-[#e5e7eb] dark:border-[#3a2e25] rounded-xl p-5">
          <h3 className="text-base font-bold text-[#1b140d] dark:text-white mb-2 flex items-center gap-2 font-display">
            <span className="material-symbols-outlined text-gray-500"><MdAnalytics/></span> Instance Details
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
            Monitor real-time availability including uptime, connected client counts, and configuration parameters to ensure high availability of the cache cluster.
          </p>
          <div className="flex flex-wrap gap-2">
            <span className="px-2 py-1 bg-white dark:bg-[#2c2219] border border-gray-200 dark:border-gray-700 rounded text-xs text-gray-500">Uptime</span>
            <span className="px-2 py-1 bg-white dark:bg-[#2c2219] border border-gray-200 dark:border-gray-700 rounded text-xs text-gray-500">Connected Clients</span>
            <span className="px-2 py-1 bg-white dark:bg-[#2c2219] border border-gray-200 dark:border-gray-700 rounded text-xs text-gray-500">Used Memory</span>
          </div>
        </div>

        <div className="bg-gray-50 dark:bg-[#1f1610] border border-[#e5e7eb] dark:border-[#3a2e25] rounded-xl p-5">
          <h3 className="text-base font-bold text-[#1b140d] dark:text-white mb-2 flex items-center gap-2 font-display">
            <span className="material-symbols-outlined text-gray-500"><MdAnalytics/></span> Performance Insights
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
            Deep dive into cache efficiency with metrics on hit/miss ratios, key eviction rates, and memory pressure. High eviction rates may signal under-provisioning, while a low hit ratio suggests ineffective caching keys.
          </p>
          <div className="flex items-center gap-4 mt-2">
            <div className="flex-1 bg-white dark:bg-[#2c2219] rounded p-2 border border-gray-200 dark:border-gray-700 text-center">
              <div className="text-xs text-gray-400 uppercase">Hit Ratio</div>
              <div className="text-lg font-bold text-green-600">94.2%</div>
            </div>
            <div className="flex-1 bg-white dark:bg-[#2c2219] rounded p-2 border border-gray-200 dark:border-gray-700 text-center">
              <div className="text-xs text-gray-400 uppercase">Evictions</div>
              <div className="text-lg font-bold text-orange-600">12/s</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);
}